<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp"> </p>
<section epub:type="epigraph" role="doc-epigraph">
<p class="EP"><span aria-label="v" id="pg_v" role="doc-pagebreak"><i>The shadows of my world extend beyond the skyline of the page, blue as tomorrow’s morning haze—nor does this terminate the phrase.</i></span></p>
<p class="EPC"><span class="small">—VLADIMIR NABOKOV</span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?53ad6510